










import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import { contains } from 'ramda'
import { getModule } from 'vuex-module-decorators'
import firebase from 'firebase/app'
import MainMixin from '../mixins/MainMixin'

@Component({
  components: {
  },
})
export default class CheckLogin extends Mixins(MainMixin) {
  online:boolean = true

  get uid() {
    if (this.$store.getters.uid) {
      return this.$store.getters.uid
    } return null
  }

  @Watch('uid', { immediate: true, deep: true })
  userLoggedIn(uid:string, old:any) {
    console.log('uid is: ', uid)
    if (uid) {
      const redirectQuery = this.$route.query.redirectUrl || undefined
      if (contains(redirectQuery, ['/location', undefined, '/login', '/check-login'])) {
        return this.$router.push('/location')
      } return this.$router.push(`/location?redirectQuery=${redirectQuery}`)
    } return true
  }
}
